const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Markets', href: '#markets' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#060606] border-t border-charcoal-border">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/6a75c8943ff93b9f13637580546a6144/e2221da1d169b5e9c147ffef050da574.png"
              alt="ABUMI Trading"
              className="h-12 w-auto object-contain mb-5"
            />
            <div className="font-heading text-lg text-white font-light mb-1">
              ABUMI Trading Company Limited
            </div>
            <div className="text-[10px] text-gold tracking-[0.2em] uppercase font-medium mb-4">
              Global Export &amp; Sourcing Solutions
            </div>
            <p className="text-[#666] text-xs leading-relaxed tracking-wide">
              Connecting China to Africa and the Middle East.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <div className="text-[10px] text-gold tracking-[0.3em] uppercase font-semibold mb-6">
              Navigation
            </div>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#666] text-xs tracking-wide hover:text-gold transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="text-[10px] text-gold tracking-[0.3em] uppercase font-semibold mb-6">
              Direct Contact
            </div>
            <div className="flex flex-col gap-4">
              <a href="tel:+8613690236065" className="flex items-start gap-3 group cursor-pointer">
                <i className="ri-phone-line text-gold text-sm mt-0.5 flex-shrink-0" />
                <span className="text-[#666] text-xs tracking-wide group-hover:text-gold transition-colors duration-300">
                  +86 136 9023 6065
                </span>
              </a>
              <a href="tel:+251915730165" className="flex items-start gap-3 group cursor-pointer">
                <i className="ri-phone-line text-gold text-sm mt-0.5 flex-shrink-0" />
                <span className="text-[#666] text-xs tracking-wide group-hover:text-gold transition-colors duration-300">
                  +251 915 730 165
                </span>
              </a>
              <a href="mailto:info@abumitrading.com" className="flex items-start gap-3 group cursor-pointer">
                <i className="ri-mail-line text-gold text-sm mt-0.5 flex-shrink-0" />
                <span className="text-[#666] text-xs tracking-wide group-hover:text-gold transition-colors duration-300">
                  info@abumitrading.com
                </span>
              </a>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-gold text-sm mt-0.5 flex-shrink-0" />
                <span className="text-[#666] text-xs tracking-wide">
                  Hong Kong, China
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-charcoal-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-[#444] text-[11px] tracking-wide">
            &copy; {year} ABUMI Trading Company Limited. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
